// Type imports:
import { OpenClosingPrice } from '../api/OpenClosingPrice';
import { IPublicOrderHistoryEntry, IPublicTradeHistoryEntry, IPublicTradeForGroup, IPublicOrderByLevel } from '../api/PublicTypes';

/* REQUEST OPEN CLOSING PRICE */
export const REQUEST_OPEN_CLOSING_PRICE_WAITING = 'REQUEST_OPEN_CLOSING_PRICE_WAITING';
export const REQUEST_OPEN_CLOSING_PRICE_SUCCESS = 'REQUEST_OPEN_CLOSING_PRICE_SUCCESS';
export const REQUEST_OPEN_CLOSING_PRICE_FAILURE = 'REQUEST_OPEN_CLOSING_PRICE_FAILURE';

interface IRequestOpenClosingPriceWaitingAction {
    type: typeof REQUEST_OPEN_CLOSING_PRICE_WAITING,
    payload: {
        symbol: string,
        fromDate: string,
        toDate: string
    }
}

interface IRequestOpenClosingPriceSuccessAction {
    type: typeof REQUEST_OPEN_CLOSING_PRICE_SUCCESS,
    payload: {
        symbol: string,
        fromDate: string,
        toDate: string,
        openClosingPrice: Array<OpenClosingPrice>
    }
}

interface IRequestOpenClosingPriceFailureAction {
    type: typeof REQUEST_OPEN_CLOSING_PRICE_FAILURE,
    payload: {
        symbol: string,
        fromDate: string,
        toDate: string,
        error: string
    }
}


/* REQUEST PUBLIC ORDERS */
export const REQUEST_PUBLIC_ORDERS_WAITING = 'REQUEST_PUBLIC_ORDERS_WAITING';
export const REQUEST_PUBLIC_ORDERS_SUCCESS = 'REQUEST_PUBLIC_ORDERS_SUCCESS';
export const REQUEST_PUBLIC_ORDERS_FAILURE = 'REQUEST_PUBLIC_ORDERS_FAILURE';

interface IRequestPublicOrdersWaitingAction {
    type: typeof REQUEST_PUBLIC_ORDERS_WAITING,
    payload: {
        symbol: string,
        tradingDay: string
    }
}

interface IRequestPublicOrdersSuccessAction {
    type: typeof REQUEST_PUBLIC_ORDERS_SUCCESS,
    payload: {
        symbol: string,
        tradingDay: string,
        orderHistory: Array<IPublicOrderHistoryEntry>,
    }
}

interface IRequestPublicOrdersFailureAction {
    type: typeof REQUEST_PUBLIC_ORDERS_FAILURE,
    payload: {
        symbol: string,
        tradingDay: string,
        error: string
    }
}

/* REQUEST PUBLIC TRADES */
export const REQUEST_PUBLIC_TRADES_WAITING = 'REQUEST_PUBLIC_TRADES_WAITING';
export const REQUEST_PUBLIC_TRADES_SUCCESS = 'REQUEST_PUBLIC_TRADES_SUCCESS';
export const REQUEST_PUBLIC_TRADES_FAILURE = 'REQUEST_PUBLIC_TRADES_FAILURE';

interface IRequestPublicTradesWaitingAction {
    type: typeof REQUEST_PUBLIC_TRADES_WAITING,
    payload: {
        symbol: string,
        tradingDay: string
    }
}

interface IRequestPublicTradesSuccessAction {
    type: typeof REQUEST_PUBLIC_TRADES_SUCCESS,
    payload: {
        symbol: string,
        tradingDay: string,
        tradeHistory: Array<IPublicTradeHistoryEntry>
    }
}

interface IRequestPublicTradesFailureAction {
    type: typeof REQUEST_PUBLIC_TRADES_FAILURE,
    payload: {
        symbol: string,
        tradingDay: string,
        error: string
    }
}


/* REQUEST PUBLIC TRADES FOR GROUP */

export const REQUEST_PUBLIC_TRADES_FOR_GROUP_WAITING = 'REQUEST_PUBLIC_TRADES_FOR_GROUP_WAITING';
export const REQUEST_PUBLIC_TRADES_FOR_GROUP_SUCCESS = 'REQUEST_PUBLIC_TRADES_FOR_GROUP_SUCCESS';
export const REQUEST_PUBLIC_TRADES_FOR_GROUP_FAILURE = 'REQUEST_PUBLIC_TRADES_FOR_GROUP_FAILURE';

interface IRequestPublicTradesForGroupWaitingAction {
    type: typeof REQUEST_PUBLIC_TRADES_FOR_GROUP_WAITING,
    payload: {
        tradingDay: string
    }
}

interface IRequestPublicTradesForGroupSuccessAction {
    type: typeof REQUEST_PUBLIC_TRADES_FOR_GROUP_SUCCESS,
    payload: {
        tradingDay: string,
        publicGroupTrades: Array<IPublicTradeForGroup>
    }
}

interface IRequestPublicTradesForGroupFailureAction {
    type: typeof REQUEST_PUBLIC_TRADES_FOR_GROUP_FAILURE,
    payload: {
        tradingDay: string,
        error: string
    }
}

/* REQUEST PRICE */
export const REQUEST_LAST_PRICE_WAITING = 'REQUEST_LAST_PRICE_WAITING';
export const REQUEST_LAST_PRICE_SUCCESS = 'REQUEST_LAST_PRICE_SUCCESS';
export const REQUEST_LAST_PRICE_FAILURE = 'REQUEST_LAST_PRICE_FAILURE';

interface IRequestLastPriceWaitingAction {
    type: typeof REQUEST_LAST_PRICE_WAITING,
    payload: {
        symbol: string,
        tradingDay: string
    }
}

interface IRequestLastPriceSuccessAction {
    type: typeof REQUEST_LAST_PRICE_SUCCESS,
    payload: {
        symbol: string,
        tradingDay: string,
        lastPrice: number | null
    }
}

interface IRequestLastPriceFailureAction {
    type: typeof REQUEST_LAST_PRICE_FAILURE,
    payload: {
        symbol: string,
        tradingDay: string,
        error: string
    }
}

/* REQUEST PREVIOUS TRADING DAY */
export const REQUEST_PREV_TRADING_DAY_WAITING = 'REQUEST_PREV_TRADING_DAY_WAITING';
export const REQUEST_PREV_TRADING_DAY_SUCCESS = 'REQUEST_PREV_TRADING_DAY_SUCCESS';
export const REQUEST_PREV_TRADING_DAY_FAILURE = 'REQUEST_PREV_TRADING_DAY_FAILURE';

interface IRequestPrevTradingDayWaitingAction {
    type: typeof REQUEST_PREV_TRADING_DAY_WAITING,
    payload: {
        symbol: string,
        tradingDay: string
    }
}

interface IRequestPrevTradingDaySuccessAction {
    type: typeof REQUEST_PREV_TRADING_DAY_SUCCESS,
    payload: {
        symbol: string,
        tradingDay: string,
        prevTradingDay: string | null
    }
}

interface IRequestPrevTradingDayFailureAction {
    type: typeof REQUEST_PREV_TRADING_DAY_FAILURE,
    payload: {
        symbol: string,
        tradingDay: string,
        error: string
    }
}

/* REQUEST PUBLIC ORDERS BY LEVEL */
export const REQUEST_PUBLIC_ORDERS_BY_LEVEL_WAITING = 'REQUEST_PUBLIC_ORDERS_BY_LEVEL_WAITING';
export const REQUEST_PUBLIC_ORDERS_BY_LEVEL_SUCCESS = 'REQUEST_PUBLIC_ORDERS_BY_LEVEL_SUCCESS';
export const REQUEST_PUBLIC_ORDERS_BY_LEVEL_FAILURE = 'REQUEST_PUBLIC_ORDERS_BY_LEVEL_FAILURE';

interface IRequestPublicOrdersByLevelWaitingAction {
    type: typeof REQUEST_PUBLIC_ORDERS_BY_LEVEL_WAITING,
    payload: {
        symbol: string,
        tradingDay: string
    }
}

interface IRequestPublicOrdersByLevelSuccessAction {
    type: typeof REQUEST_PUBLIC_ORDERS_BY_LEVEL_SUCCESS,
    payload: {
        symbol: string,
        tradingDay: string,
        publicOrdersByLevel: Array<IPublicOrderByLevel>,
    }
}

interface IRequestPublicOrdersByLevelFailureAction {
    type: typeof REQUEST_PUBLIC_ORDERS_BY_LEVEL_FAILURE,
    payload: {
        symbol: string,
        tradingDay: string,
        error: string
    }
}


/* EXPORT */
export type PublicActions =
// Request open closing price.
IRequestOpenClosingPriceWaitingAction
| IRequestOpenClosingPriceSuccessAction
| IRequestOpenClosingPriceFailureAction
// Request public orders.
| IRequestPublicOrdersWaitingAction
| IRequestPublicOrdersSuccessAction
| IRequestPublicOrdersFailureAction
// Request public trades.
| IRequestPublicTradesWaitingAction
| IRequestPublicTradesSuccessAction
| IRequestPublicTradesFailureAction
// Request public trades for group.
| IRequestPublicTradesForGroupWaitingAction
| IRequestPublicTradesForGroupSuccessAction
| IRequestPublicTradesForGroupFailureAction
// Request last price.
| IRequestLastPriceWaitingAction
| IRequestLastPriceSuccessAction
| IRequestLastPriceFailureAction
// Request Prev Trading Day
| IRequestPrevTradingDayWaitingAction
| IRequestPrevTradingDaySuccessAction
| IRequestPrevTradingDayFailureAction
// Request public orders by level
| IRequestPublicOrdersByLevelWaitingAction
| IRequestPublicOrdersByLevelSuccessAction
| IRequestPublicOrdersByLevelFailureAction;